module.exports = __webpack_public_path__ + "img/new-ticket-reply.172291ff.svg";